import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'info-tooltip',
    templateUrl: './info-tooltip.component.html',
    styleUrls: ['./info-tooltip.component.scss'],
    standalone: false
})
export class InfoTooltipComponent implements OnInit {
  @Input() tooltip: string;
  constructor() { }

  ngOnInit(): void {
  }

}
